import { render, staticRenderFns } from "./PageHeroLarge.vue?vue&type=template&id=10563e80"
import script from "./PageHeroLarge.vue?vue&type=script&lang=js"
export * from "./PageHeroLarge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CImage: require('/vercel/path0/components/ui/c-image.vue').default})
